import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const CONTENT_SECTIONS = [
  { key: "hero_title_full", label: "Hero title", type: "text" },
  { key: "hero_tagline", label: "Hero tagline (long paragraph)", type: "textarea" },
  { key: "artist_title", label: "Artist section title", type: "text" },
  { key: "artist_body", label: "Artist section body", type: "textarea" },
  { key: "recent_title", label: "Recent works title", type: "text" },
  { key: "envision_title", label: "Envision CTA title", type: "text" },
  { key: "envision_body", label: "Envision CTA body", type: "textarea" },
  { key: "gallery_title", label: "Gallery page title", type: "text" },
  { key: "gallery_intro", label: "Gallery intro", type: "textarea" },
  { key: "custom_title", label: "Commission page title", type: "text" },
  { key: "custom_intro", label: "Commission page intro", type: "textarea" },
  { key: "contact_title", label: "Contact page title", type: "text" },
  { key: "contact_intro", label: "Contact page intro", type: "textarea" },
  { key: "reviews_page_title", label: "Reviews page title", type: "text" },
];

export function Content() {
  const [values, setValues] = useState({});
  const [initial, setInitial] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/content").then(r => {
      setValues(r.data);
      setInitial(r.data);
      setLoading(false);
    });
  }, []);
  const save = async () => {
    setSaving(true);
    try {
      // Only send fields the admin actually changed (non-empty edits)
      const updates = {};
      CONTENT_SECTIONS.forEach(s => {
        const v = (values[s.key] || "").trim();
        const orig = (initial[s.key] || "").trim();
        if (v !== orig) updates[s.key] = v;
      });
      if (Object.keys(updates).length === 0) {
        toast.info("No changes to save.");
        setSaving(false);
        return;
      }
      await api.patch("/admin/content", { updates });
      setInitial({ ...initial, ...updates });
      toast.success(`Saved ${Object.keys(updates).length} change(s). Refresh public site to see.`);
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };
  return (
    <div>
      <h1 className="font-serif text-4xl mb-1">Site Copy</h1>
      <div className="overline text-white/40 mb-8">Edit the wording of every page</div>
      <div className="surface p-6 space-y-5">
        {loading ? <div className="text-white/50 py-8 text-center">Loading current copy…</div> : (
          <>
            {CONTENT_SECTIONS.map(s => (
              <div key={s.key}>
                <div className="overline text-white/50 mb-2">{s.label}</div>
                {s.type === "textarea" ? (
                  <textarea rows={3} data-testid={`copy-${s.key}`} className="w-full bg-black/40 border border-white/10 px-3 py-2 text-sm text-white/90"
                    value={values[s.key] || ""} onChange={e => setValues({ ...values, [s.key]: e.target.value })}/>
                ) : (
                  <input data-testid={`copy-${s.key}`} className="w-full bg-black/40 border border-white/10 px-3 py-2 text-sm text-white/90"
                    value={values[s.key] || ""} onChange={e => setValues({ ...values, [s.key]: e.target.value })}/>
                )}
              </div>
            ))}
            <div className="flex items-center gap-3">
              <button onClick={save} disabled={saving} data-testid="content-save"
                className="bg-white text-black px-6 py-2 text-xs uppercase tracking-widest disabled:opacity-50">
                {saving ? "Saving…" : "Save Changes"}
              </button>
              <span className="text-xs text-white/40">Blank a field to restore its default text.</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

